<div class="layout-wrapper" [class.layout-wrapper--producer]="isProducerArea">
  <app-navbar [isProducerArea]="isProducerArea"></app-navbar>
  <div class="content-wrapper" [ngClass]="{ 'producer-area': isProducerArea }">
    <div class="sidebar-container">
      <app-sidebar [isProducerArea]="isProducerArea"></app-sidebar>
    </div>
    <div class="main-content container-fluid p-0 m-0">
      <ng-content></ng-content>
    </div>
  </div>
  @if (!isProducerArea) {
    <app-footer />
  }
</div>
